import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useCreateServiceJobMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IServiceJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			job,
			impersonationContext,
		}: {
			job: Partial<Api.IServiceJob>;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IServiceJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'ServiceJob',
				}),
				'POST',
				job
			);
		},
		onError,
		onSuccess,
	});
};
